import theme from '@raptormaps/theme';
import styled from 'styled-components';

export const InfoItem = styled.p.attrs(() => ({
  className: 'EditTabs__InfoItem',
}))`
  margin: 0px;
`;

export const InfoItemTitle = styled.span.attrs(() => ({
  className: 'EditTabs__InfoItem_Title',
}))<{ required: boolean }>`
  font-weight: 500;

  color: ${({ required }) => {
    if (required) {
      return theme.colors.red_500;
    } else {
      return theme.colors.neutral_900;
    }
  }};
`;
